var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBinanceSmartChainBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F3BA2F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2236 23.931V26.6207L15.8788 28L13.6029 26.6207V23.931L15.8788 25.3103L18.2236 23.931ZM5.67188 14.6207L7.94774 16V20.6207L11.8788 22.9655V25.6552L5.67188 22V14.6207ZM26.0857 14.6207V22L19.8098 25.6552V22.9655L23.7408 20.6207V16L26.0857 14.6207ZM19.8098 10.9655L22.1546 12.3448V15.0345L18.2236 17.3793V22.069L15.9477 23.4483L13.6719 22.069V17.3793L9.60291 15.0345V12.3448L11.9477 10.9655L15.8788 13.3103L19.8098 10.9655ZM9.60291 16.9655L11.8788 18.3448V21.0345L9.60291 19.6552V16.9655ZM22.1546 16.9655V19.6552L19.8788 21.0345V18.3448L22.1546 16.9655ZM7.94774 8.62069L10.2926 10L7.94774 11.3793V14.069L5.67188 12.6897V10L7.94774 8.62069ZM23.8098 8.62069L26.1546 10V12.6897L23.8098 14.069V11.3793L21.5339 10L23.8098 8.62069ZM15.8788 8.62069L18.2236 10L15.8788 11.3793L13.6029 10L15.8788 8.62069ZM15.8788 4L22.1546 7.65517L19.8788 9.03448L15.9477 6.68965L11.9477 9.03448L9.67187 7.65517L15.8788 4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinanceSmartChainBadge);
export default __webpack_public_path__ + "static/media/BinanceSmartChainBadge.d8a990a264485adddd99173f9c1beaf8.svg";
export { ForwardRef as ReactComponent };